const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userConfig: state => state.user.userConfig,
  wxUserInfo: state => state.user.wxUserInfo,
  vrbase: state => state.vredit.vrbase,
  siteInfo:state=>state.siteConfig.siteInfo,
  currentScenesId: state => state.vredit.currentScenesId,
  currentGuidePointId: state => state.vredit.currentGuidePointId,
  currentHlookat: state => state.vredit.currentHlookat,
  permission_routes: state => state.user.permission,
  editSandtable: state => {
    if (Object.keys(state.vredit.vrbase).length > 0 && state.vredit.vrbase.sandtable.length > 0) {
      // return state.vredit.vrbase.sandtable[0];
      return state.vredit.vrbase.sandtable[state.vredit.selectImgIndex];
    } else {
      return { url: "", scenes: {} }
    }
  },
  editGuide: state => {
    console.log(
      'editGuide的state',
      '\nObject.keys(state.vredit.vrbase).length:',Object.keys(state.vredit.vrbase).length,
      '\nstate.vredit.vrbase.guide.length:',state.vredit.vrbase.guide.length
    )
    if (Object.keys(state.vredit.vrbase).length > 0 && state.vredit.vrbase.guide.length > 0) {
      return state.vredit.vrbase.guide[0];
    } else {
      return {
        name: "",
        start_img: "",
        end_img: "",
        points: [],
      }
    }
  },
  sandTable: state => {
    if (Object.keys(state.vredit.vrbase).length > 0 && state.vredit.vrbase.sandtable.length > 0) {
      return state.vredit.vrbase.sandtable;
    } else {
      return [];
    }
  },
  sandTableImg: state => {
    let imgList = [];
    if (Object.keys(state.vredit.vrbase).length > 0 && state.vredit.vrbase.sandtable.length > 0) {
      for (let i = 0; i < state.vredit.vrbase.sandtable.length; i++) {
        imgList.push(state.vredit.vrbase.sandtable[i].url)
      }
      // imgList = state.vredit.vrbase.sandtable.map((item, index) => {
      //   return item.url
      // })
    }else{
      imgList = [];
    }
    return imgList;
  },
  imgIndex: state => state.vredit.selectImgIndex,
}

export default getters